<template>
  <router-view />
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {

    }
  }
}
</script>

<style lang='scss' scoped>
</style>
